<div class="new-manager">
    <div class="main-new-manager">
        <div class="dialog-title-row">
            <h1 class="title-new-manager m-0">{{editBond ? 'Editar' : 'Crear'}} Abono</h1>
            <button class="btn-close-dialog" mat-dialog-close><i class="fa-light fa-times"></i></button>
        </div>
        <div class="form-info-user">
            <form class="form-grid" [formGroup]="formNewPass">
                <!-- <div class="main-inputs"> -->
                    <div class="mb-3">
                        <p class="label-input">Nombre<span class="required-field">*</span></p>
                        <div class="form-input-container ">
                            <input type="text" class="w-100" formControlName="name" [required]="true">
                        </div>
                    </div>
                    <!-- <div>
                        <p class="label-input">Código</p>
                        <div class="form-input-container ">
                            <input type="text" class="w-100" formControlName="code">
                        </div>
                    </div> -->
                <!-- </div> -->
                <div class="main-inputs">
                    <div>
                        <p class="label-input">Descuento €<span class="required-field">*</span></p>
                        <mat-form-field appearance="fill" class="filter-place form-input-container">
                            <mat-select placeholder="Tipo de descuento" formControlName="type">
                                <mat-option value="amount">Cantidad total</mat-option>
                                <mat-option value="percentage">Porcentaje</mat-option>
                            </mat-select>
                            <mat-select-trigger matSuffix style="vertical-align: middle;">
                                <i class="fal fa-angle-down pointer-in"></i>
                            </mat-select-trigger>
                        </mat-form-field>
                    </div>
                    <div>
                        <p class="label-input">Cantidad<span class="required-field">*</span></p>
                        <div class="form-input-container d-flex">
                            <input type="number" class="w-100" formControlName="cuantity">
                            <i matSuffix>{{formNewPass.value.type == 'amount' ? '€' : '%'}}</i>
                        </div>

                    </div>
                    <!-- <div class="padding-inputs">
                        <div>
                            <p class="title-dates-inputs">Fecha inicio</p>
                            <div class="section-input">
                                <div class="d-flex align-items-center justify-content-between input-border">
                                    <div class="select-style calendar-date pointer-in"
                                        [class.active]="typeDatepicker == 'start'" (click)="openDatePicker('start')">
                                        <i class="fa-light fa-calendar"></i>
                                        <input placeholder="Inicio de venta" class="input-date pointer-in" readonly
                                            [(ngModel)]="startStringDate" [ngModelOptions]="{standalone: true}">
                                        <i class="icon-down fa-light fa-chevron-down"></i>
                                    </div>
                                </div>

                                <div class="d-flex align-items-center justify-content-center inputs-hours"
                                    [class.error-input]="hourInit > 23 || hourInit < 0 || minuteInit < 0 || minuteInit > 59 || minuteInit?.length > 2">
                                    <div class="input-hour">
                                        <input placeholder="20" type="number" min="0" max="23"
                                            (ngModelChange)="changeHourInit($event)" [ngModel]="(hourInit|number:'2.0-0')"
                                            [ngModelOptions]="{standalone: true}" />
                                    </div>
                                    <span class="points">:</span>
                                    <div class="input-hour">
                                        <input placeholder="00" type="number" min="0" max="59"
                                            (ngModelChange)="changeMinuteInit($event)" [ngModel]="minuteInit"
                                            [ngModelOptions]="{standalone: true}" />
                                    </div>
                                </div>
                            </div>
                            <div class="calendar-option" *ngIf="typeDatepicker == 'start'">
                                <app-calendar-event-dates [selectedDate]="startDate" (saveDate)="saveDate($event)"
                                    [minDate]="dateOld"></app-calendar-event-dates>
                            </div>
                        </div>
                        <div>
                            <p class="title-dates-inputs">Fecha fin</p>
                            <div class="section-input">
                                <div class="d-flex align-items-center justify-content-between input-border">
                                    <div class="select-style calendar-date pointer-in" [class.active]="typeDatepicker == 'end'"
                                        (click)="openDatePicker('end')">
                                        <i class="fa-light fa-calendar"></i>
                                        <input placeholder="Fin de venta" class="input-date pointer-in" readonly
                                            [(ngModel)]="endStringDate" [ngModelOptions]="{standalone: true}">
                                        <i class="icon-down fa-light fa-chevron-down"></i>
                                    </div>
                                </div>

                                <div class="d-flex align-items-center justify-content-center inputs-hours"
                                    [class.error-input]="hourEnd > 23 || hourEnd < 0 || minuteEnd < 0 || minuteEnd > 59 || minuteEnd?.length > 2">
                                    <div class="input-hour">
                                        <input placeholder="20" type="number" min="0" max="23"
                                            [ngModel]="hourEnd|number:'2.0-0'" (ngModelChange)="changeHourEnd($event)"
                                            [ngModelOptions]="{standalone: true}" />
                                    </div>
                                    <span class="points">:</span>
                                    <div class="input-hour">
                                        <input placeholder="00" type="number" min="0" max="59"
                                            (ngModelChange)="changeMinuteEnd($event)" [ngModel]="minuteEnd"
                                            [ngModelOptions]="{standalone: true}" />
                                    </div>
                                </div>
                            </div>
                            <div class="calendar-option" *ngIf="typeDatepicker == 'end'">
                                <app-calendar-event-dates [selectedDate]="endDate" (saveDate)="saveDate($event)"
                                    [minDate]="startDate"></app-calendar-event-dates>
                            </div>
                        </div>
                    </div> -->
                    
                </div>
            </form>
        </div>        
    </div>
    <mat-divider></mat-divider>
    <div class="footer-new-manager">
        <div class="btn-new btn-create m-0" (click)="nextStep()"
            [class.disabled]="formNewPass.invalid">
            <p class="m-0">Siguiente</p>
        </div>
    </div>
</div>